import {mergeDeepObject} from "./_util";
import {Popover} from "../../index.esm";
import Scrollbar from "smooth-scrollbar";
import {loadLib} from "../../../frontend/js/project/src/utils/loadLib";

const VegasUI = {
	boot: async () => {
		// Popovers
		let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.map(function (popoverTriggerEl) {
			return new Popover(popoverTriggerEl, {
				html: true,
				container: 'body',
			})
		});

		// Tooltip
		let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		if (tooltipTriggerList.length) {
			const Tooltip = await loadLib.tooltip();
			tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new Tooltip(tooltipTriggerEl, {
					trigger: 'hover'
				})
			});
		}
	},

	fancybox: async (target = "[data-fancybox]", params = {}) => {
		if (!document.querySelector(target)) {
			return;
		}

		const Fancybox = await loadLib.fancybox();

		Fancybox.bind(target, mergeDeepObject(params, {
			Hash: false,
			Image: {
				zoom: false,
			}
		}));
	},

	scrollbar: function ($selectors = [], arg = {}) {
		let scrollbars = [];

		if ($selectors.length) {
			scrollbars = $selectors;
		} else {
			scrollbars = document.querySelectorAll('[data-scrollbar]');
		}

		if (scrollbars.length) {
			for (let bar of scrollbars) {
				let option = mergeDeepObject({
					damping: parseInt(bar.dataset.damping) || .1,
					thumbMinSize: parseInt(bar.dataset.thumbMinSize) || 20,
					renderByPixels: bar.dataset.renderByPixels !== 'false',
					alwaysShowTracks: bar.dataset.alwaysShowTracks || false,
				}, arg);

				Scrollbar.init(bar, option);
			}
		}
	},
}

function onReady() {
	// Boot
	VegasUI.boot();

	// Fancybox
	VegasUI.fancybox();

	// ScrollBar
	VegasUI.scrollbar();
}

document.addEventListener("DOMContentLoaded", onReady);
document.addEventListener("turbo:render", (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;
	onReady();
});

export default VegasUI;
